// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1LGmx","range":"MonthRangeSwitch_range__3PEEi","disabled":"MonthRangeSwitch_disabled__2m5ur"};